import { motion } from "framer-motion";
import type { GiftTheme } from "@/lib/gift-utils";

interface Props {
  message: string;
  senderName?: string | null;
  theme: GiftTheme;
  isDark?: boolean;
  accentColor?: string;
}

const GiftMessageCard = ({ message, senderName, theme, isDark, accentColor }: Props) => {
  const quoteColor = isDark ? (accentColor || "rgba(212,175,55,0.3)") : (accentColor || "rgba(108,99,255,0.25)");

  return (
    <motion.div
      className="w-full rounded-[20px] p-6 relative overflow-hidden"
      style={{
        background: theme.messageBg,
        border: theme.messageBorder,
      }}
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.4 }}
    >
      {/* Decorative quote mark */}
      <div
        className="absolute top-3 left-5 text-[48px] font-serif leading-none pointer-events-none select-none"
        style={{ color: quoteColor, opacity: 0.3 }}
      >
        «
      </div>

      <p
        className="text-[11px] tracking-[0.15em] uppercase font-medium mb-4 relative z-10"
        style={{ color: theme.textTertiary }}
      >
        💌 {senderName ? `Сообщение от ${senderName}` : "Личное сообщение"}
      </p>
      <p
        className="text-[15px] leading-relaxed relative z-10"
        style={{ color: theme.textSecondary, fontStyle: "italic" }}
      >
        «{message}»
      </p>
    </motion.div>
  );
};

export default GiftMessageCard;
